import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  actionButton: {
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 600,
    "&.Mui-disabled": {
      // backgroundColor: theme.palette.success.main,
      opacity: "unset",
      color: "#fff",
    },
  },
  tableText: {
    // font: "normal normal normal 14px/16px Helvetica",
    color: "#9A9A9A",
  },
  paidButton: {
    backgroundColor: theme.palette.success.main,
    color: "#fff",
    "&.Mui-disabled": {
      backgroundColor: theme.palette.success.main,
      opacity: "unset",
      color: "#fff",
    },
  },
}))

export default styles
